// extracted by mini-css-extract-plugin
export default {"glContainer":"WebGLView_glContainer__YY5nI"};